import React from 'react';
import CbmContainer from '../containers/CbmContainer';

const CbmPage = () => {
    return (
        <>
            <CbmContainer />
        </>
    );
};

export default CbmPage;
